webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

__webpack_require__(3);

__webpack_require__(1);

__webpack_require__(2);

/***/ },
/* 1 */
/***/ function(module, exports) {

"use strict";
'use strict';

function getPrice() {

    var bookPrice = 29.8,
        deliveryPrice = 3,
        higherDeliveryPrice = 6,
        count = document.getElementById('input-count').value,
        priceContainer = document.getElementById('price-full'),
        deliveryPriceContainer = document.getElementById('price-delivery'),
        price = void 0;

    // IF 1 BOOK, ADD FIX PRICE
    if (count <= 1) {
        price = bookPrice + deliveryPrice;
        deliveryPriceContainer.innerText = deliveryPrice;
    } else {
        price = bookPrice * count + higherDeliveryPrice;
        deliveryPriceContainer.innerText = higherDeliveryPrice;
    }

    // REPLACE CURRENCY DISPLAY
    price = price.toString().replace('.', ',');

    // ADD SECOND 0 IF NECESSARY
    if (price.length - price.indexOf(',') == 2) price += '0';

    // CHECK IF MORE THAN TWO DECIMALS
    if (price.indexOf(',') > 2) {

        var commaPosition = price.indexOf(','),
            dump = price.substr(commaPosition + 3, price.length);

        price = price.replace(dump, '');
    }

    priceContainer.innerText = price;
}

getPrice();

function updatePrice() {

    var countInput = document.getElementById('input-count');

    countInput.addEventListener('keyup', function () {
        return getPrice();
    });
    countInput.addEventListener('mouseup', function () {
        return getPrice();
    });
}

updatePrice();

/***/ },
/* 2 */
/***/ function(module, exports) {

"use strict";
'use strict';

function setCountry() {

    var countrySelector = document.getElementById('select-country'),
        disabledCountryInput = document.getElementById('form-country');

    countrySelector.addEventListener('change', function () {
        console.log(this.options[this.selectedIndex].text);

        disabledCountryInput.value = this.options[this.selectedIndex].text;
    });
}

setCountry();

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _validateJs = __webpack_require__(4);

var _validateJs2 = _interopRequireDefault(_validateJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fields = [{
    name: 'payment-method',
    display: 'Zahlungsart',
    rules: 'required'
}, {
    name: 'surname',
    display: 'Nachname',
    rules: 'required'
}, {
    name: 'forename',
    display: 'Vorname',
    rules: 'required'
}, {
    name: 'street',
    display: 'Straße und Hausnummer',
    rules: 'required'
}, {
    name: 'zip',
    display: 'Postleitzahl',
    rules: 'required'
}, {
    name: 'place',
    display: 'Ort',
    rules: 'required'
}, {
    name: 'email',
    display: 'E-Mail',
    rules: 'required'
}, {
    name: 'email-confirm',
    display: 'E-Mail-Bestätigung',
    rules: 'required|matches[email]'
}];

var cb = function cb(errors, event) {

    var box = document.querySelector('.error-box');

    if (errors.length > 0) {

        var errorString = '',
            errorLength = errors.length,
            formField = document.querySelectorAll('.form-field'),
            inputField = void 0;

        // reset errors
        for (var i = 0; i < formField.length; i++) {
            formField[i].classList.remove('has-error');
        }for (var _i = 0; _i < errorLength; _i++) {

            // write message
            errorString += errors[_i].message + '<br>';

            // set error class
            inputField = document.getElementsByName(errors[_i].name);

            for (var x = 0; x < inputField.length; x++) {
                inputField[x].parentNode.classList.add('has-error');
            }
        }

        box.children[0].innerHTML = errorString;
        box.classList.add('is-visible');
    }
};

var validator = new _validateJs2.default('book-order', fields, cb);

validator.setMessage('required', 'Bitte füllen Sie das Feld %s aus.');
validator.setMessage('matches', 'Die %s stimmt nicht überein.');

/***/ },
/* 4 */,
/* 5 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(0);


/***/ }
],[5]);


// WEBPACK FOOTER //
// main.js